<template>
  <div>
    <h1>Erro ao renderizar o relatório</h1>
  </div>
</template>

<script>
export default {
  name: 'UnknownTypeBI',
}
</script>
